// Plain-English privacy policy for the public site. Starter template - have an
// attorney review before relying on it. Reachable at /privacy.
const UPDATED = "July 1, 2026";

export default function PrivacyPage() {
  return (
    <main className="legal">
      <a className="legal-back" href="/">&larr; Back to Mizpah</a>
      <h1>Privacy Policy</h1>
      <p className="legal-date">Last updated: {UPDATED}</p>

      <p>
        Mizpah Center for Allied Health Education ("Mizpah," "we," "us") respects your
        privacy. This policy explains what information we collect through our website
        and student portal, how we use it, and the choices you have.
      </p>

      <h2>Information we collect</h2>
      <ul>
        <li><strong>Information you give us on our inquiry form:</strong> your name, email
          address, phone number, mailing address (optional), the program you are interested
          in, your preferred start month, and any message you choose to include.</li>
        <li><strong>Enrollment and student information:</strong> if you enroll, records related
          to your program, and documents you upload to your student portal (for example, a
          health physical form or TB screening form).</li>
        <li><strong>Basic technical information:</strong> standard server log data such as your
          browser type and the pages you visit, used to keep the site secure and working.</li>
      </ul>

      <h2>How we use your information</h2>
      <ul>
        <li>To respond to your inquiry and send you program details and a brochure.</li>
        <li>To process and manage your enrollment and provide student services.</li>
        <li>To communicate with you about your program, classes, and assignments.</li>
        <li>To operate, secure, and improve our website and student portal.</li>
        <li>To comply with our legal and regulatory obligations.</li>
      </ul>

      <h2>How we share your information</h2>
      <p><strong>We do not sell your personal information.</strong> We share it only:</p>
      <ul>
        <li>With service providers who help us operate (for example, our cloud hosting and
          email-delivery providers), who may only use it to provide services to us.</li>
        <li>When required by law, or to protect the rights, safety, or property of Mizpah,
          our students, or others.</li>
        <li>With your consent.</li>
      </ul>

      <h2>Email communications</h2>
      <p>
        When you contact us we send a confirmation and program information. If you do not
        enroll, we may send a small number of follow-up messages. You can opt out of those
        follow-ups at any time using the unsubscribe link in the email or by contacting us
        at the details below. Essential messages about an active enrollment (such as class
        or assignment notices) are part of the service you signed up for.
      </p>

      <h2>How we protect your information</h2>
      <p>
        We use industry-standard safeguards, including encryption of your data in transit and
        at rest and access controls that limit who can view student records. No method of
        transmission or storage is ever completely secure, but we work to protect your
        information and to keep it only as long as we need it for the purposes above or as the
        law requires.
      </p>

      <h2>Your choices</h2>
      <p>
        You may ask us to access, correct, or delete the personal information we hold about
        you, and you may opt out of follow-up emails. Contact us using the details below and
        we will respond within a reasonable time.
      </p>

      <h2>Cookies and tracking</h2>
      <p>
        Our student portal uses only the essential cookies and local storage needed to keep
        you signed in. We do not use advertising cookies or cross-site tracking.
      </p>

      <h2>Children's privacy</h2>
      <p>
        Our programs and website are intended for adults. We do not knowingly collect
        personal information from children under 16.
      </p>

      <h2>Changes to this policy</h2>
      <p>
        We may update this policy from time to time. When we do, we will change the "last
        updated" date above.
      </p>

      <h2>Contact us</h2>
      <p>
        Mizpah Center for Allied Health Education<br />
        2720 S River Rd, Suite 2, Des Plaines, IL 60018<br />
        Phone: (847) 708-9266 or (224) 436-9371<br />
        Email: mizpahchicago@gmail.com
      </p>
    </main>
  );
}
